<template>
  <article class="feed-item event comment">
    <div class="time">{{ formattedTime }}</div>

    <div class="feed-item-content">
      <div class="author">{{ author }}</div>
      <div class="body">{{ body }}</div>
    </div>
  </article>
</template>

<script lang="ts">
import { PropType } from 'vue';
import FeedRecord   from '@/core/services/Feeds/FeedRecord';
import Comment      from '@/core/services/Comments/Comment';

export default defineComponent({
  name: 'FeedItemComment',

  props: {
    record: {
      type:     Object as PropType<FeedRecord>,
      required: true,
    },
  },

  computed: {
    payload(): Comment {
      return this.record.payload as Comment;
    },

    author(): string {
      return this.payload.createdBy?.name ?? 'Неизвестный автор';
    },

    body(): string {
      return this.payload.body ?? '';
    },

    formattedTime(): string {
      return this.record.time.format('HH|mm');
    },
  },
});
</script>